<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">

      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Devices</a></li>
          <li><a>Monitor</a></li>
        </ul>
      </div>

      <div class="panel panel-default" [hidden]="!pgLoad">
        <div class="panel-body table-responsive" [hidden]="!pgLoad">
          <table class="table table-striped table-bordered table-hover">
            <thead>
            <tr>
              <th colspan="8">Device Data</th>
              <th colspan="5">pH</th>
              <th colspan="5">DO(Dissolved Oxygen)</th>
              <th colspan="5">EC(Electrical Conductivity)</th>
            </tr>
            <tr>
              <th class="handSymbol" (click)="sortingTanks('device')">Device/Serial No
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':deviceAsc,'glyphicon-chevron-down':!deviceAsc}"></span>
              </th>
              <th>Total Tests
              </th>
              <th>Avg. Tests Per Day</th>
              <th class="handSymbol" (click)="sortingTanks('startdate')">Start Date
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':startdateAsc,'glyphicon-chevron-down':!startdateAsc}"></span>
              </th>
              <th>Last test date</th>
              <th>Idle Time Occurence</th>
              <th>Idle Time Range</th>
              <th>Idle Time Score</th>
              <th>Last Calibration Date</th>
              <th>Total Calibration Attempts</th>
              <th>Successful Calibrations</th>
              <th>Calibration Efficiency</th>
              <th>Sensor Health Score</th>
              <th>Last Calibration Date</th>
              <th>Total Calibration Attempts</th>
              <th>Successful Calibrations</th>
              <th>Calibration Efficiency</th>
              <th>Sensor Health Score</th>
              <th>Last Calibration Date</th>
              <th>Total Calibration Attempts</th>
              <th>Successful Calibrations</th>
              <th>Calibration Efficiency</th>
              <th>Sensor Health Score</th>
            </tr>
            </thead>
            <tbody>
            <tr class="searchfun"
              *ngFor="let list of deviceHealths |  paginate: { itemsPerPage: noofitemsPerPage, currentPage: currentpagenum }; let i = index">
              <td>{{list && list.device_number}}</td>
              <td>{{list && list.data && list.data.device_data && list.data.device_data.total_tests}}</td>
              <td>{{list && list.data && list.data.device_data && list.data.device_data.avg_test_per_day}}</td>
              <td>{{(list && list.data && list.data.device_data && list.data.device_data.start_date == null) ? '--' : ((list && list.data && list.data.device_data && list.data.device_data.start_date)| date:"dd-MMM-yyyy hh:mm:ss a")}}</td>
              <td>{{(list && list.data && list.data.device_data && list.data.device_data.last_test_date == null) ? '--' : ((list && list.data && list.data.device_data && list.data.device_data.last_test_date)| date:"dd-MMM-yyyy hh:mm:ss a")}}</td>
              <td>{{list && list.data && list.data.device_data && list.data.device_data.idle_time_occurence}}</td>
              <td>{{list && list.data && list.data.device_data && list.data.device_data.idle_time_range}}</td>
              <td>{{list && list.data && list.data.device_data && list.data.device_data.idle_time_score}}</td>
              <td>{{(list && list.data && list.data.pH && list.data.pH.last_calibration_date == null) ? '--' : ((list && list.data && list.data.pH && list.data.pH.last_calibration_date)| date:"dd-MMM-yyyy")}}</td>
              <td>{{list && list.data && list.data.pH && list.data.pH.total_calibration_attempts}}</td>
              <td>{{list && list.data && list.data.pH && list.data.pH.successful_calibrations}}</td>
              <td>{{(list && list.data && list.data.pH && list.data.pH.calibration_efficiency == "None") ? '--' : (list && list.data && list.data.pH && list.data.pH.calibration_efficiency)}}</td>
              <td>{{(list && list.data && list.data.pH && list.data.pH.sensor_health_score == "None") ? '--' : (list && list.data && list.data.pH && list.data.pH.sensor_health_score).toFixed(2)}}</td>
              <td>{{(list && list.data && list.data.DO && list.data.DO.last_calibration_date == null) ? '--' : ((list && list.data && list.data.DO && list.data.DO.last_calibration_date)| date:"dd-MMM-yyyy")}}</td>
              <td>{{list && list.data && list.data.DO && list.data.DO.total_calibration_attempts}}</td>
              <td>{{list && list.data && list.data.DO && list.data.DO.successful_calibrations}}</td>
              <td>{{(list && list.data && list.data.DO && list.data.DO.calibration_efficiency == "None") ? '--' :  list && list.data && list.data.DO && list.data.DO.calibration_efficiency}}</td>
              <td>{{(list && list.data && list.data.DO && list.data.DO.sensor_health_score).toFixed(2)}}</td>
              <td>{{(list && list.data && list.data.EC && list.data.EC.last_calibration_date == null) ? '--' : ((list && list.data && list.data.EC && list.data.EC.last_calibration_date)| date:"dd-MMM-yyyy")}}</td>
              <td>{{list && list.data && list.data.EC && list.data.EC.total_calibration_attempts}}</td>
              <td>{{list && list.data && list.data.EC && list.data.EC.successful_calibrations}}</td>
              <td>{{(list && list.data && list.data.EC && list.data.EC.calibration_efficiency == "None") ? '--' : (list && list.data && list.data.EC && list.data.EC.calibration_efficiency)}}</td>
              <td>{{(list && list.data && list.data.EC && list.data.EC.sensor_health_score == "None") ? '--' : (list && list.data && list.data.EC && list.data.EC.sensor_health_score).toFixed(2)}}</td>
            </tr>
            </tbody>
          </table>
          <div class="pull-right pagination_div" *ngIf="deviceHealths && deviceHealths.length > 10">
            <pagination-controls (pageChange)="currentpagenum = $event" (click)="pageChange(currentpagenum)"></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END PAGE CONTENT WRAPPER -->
</div>
<!-- END PAGE CONTENT WRAPPER -->

